import '@aws-amplify/ui-react/styles.css';
import React from "react";
import { Authenticator } from '@aws-amplify/ui-react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { CacheProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import theme from '../src/theme';
import createEmotionCache from '../src/createEmotionCache';
import GiddyupAppBar from './components/GiddyupAppBar';
import Router from './components/Router';
import './App.css';

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

function App(props) {
  const { emotionCache = clientSideEmotionCache } = props;
  const initState = document.URL.includes('/signup') ? 'signUp' : undefined
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CacheProvider value={emotionCache}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Authenticator initialState={initState} components={{ Header: GiddyupAppBar }}>
            {({ signOut, user }) => (
              <div className="App">
                <Router signOut={signOut} user={user} />
              </div>
            )}
          </Authenticator>
        </Box>
      </CacheProvider>
    </ThemeProvider>
  );
}

export default App;
